import { render, staticRenderFns } from "./BusinessOtherShareholdersYN.vue?vue&type=template&id=1ed012b4"
import script from "./BusinessOtherShareholdersYN.vue?vue&type=script&lang=js"
export * from "./BusinessOtherShareholdersYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports